import React from 'react';
import ReactDom from 'react-dom';
import PropTypes from 'prop-types';

const FakePage = ({ children, className = '', isOpen }) => {
  if (!isOpen) return null;

  return ReactDom.createPortal(
    <div className={`fake-page ${className}`}>{children}</div>,
    document.getElementById('root'),
  );
};

FakePage.propsTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  isOpen: PropTypes.bool.isRequired,
};

export default FakePage;
